export default {
    userId: 'user_ywzILF3A32TAHWaOSTOOv',
    serviceId: 'service_wd9vljy',
    templateId: 'template_mvikj16'
}